import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NxToastRegion } from '@soft2code/nexpo-lib/ui';

@Component({
	selector: 'app-root',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [RouterOutlet, NxToastRegion],
	template: '<router-outlet /><nx-toast-region />',
})
export class App {}
